export const intTelConfig = {
    initialCountry: 'pl',
    separateDialCode: true,
    placeholderNumberType: "MOBILE",
    customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
        return "e.g. " + selectedCountryPlaceholder;
    },
    hiddenInput: function(telInputName) {
        return {
            phone: "phone_full",
            country: "country_code"
        };
    },
    utilsScript: import('intl-tel-input/build/js/utils.js'),
    i18n: {
        searchPlaceholder: 'Szukaj',
        pl: 'Polska',
        de: 'Niemcy',
        en: 'Anglia',
        fr: 'Francja',
        es: 'Hiszpania',
        it: 'Włochy',
        ru: 'Rosja',
        ja: 'Japonia',
        zh: 'Chiny',
        pt: 'Portugalia',
        ko: 'Korea',
        vi: 'Wietnam',
        uk: 'Ukraina',
        cs: 'Czechy',
        el: 'Grecja',
        nb: 'Norwegia',
        nn: 'Norwegia',
        tr: 'Turcja',
        hu: 'Węgry',
        ro: 'Rumunia',
        sk: 'Słowacja',
        da: 'Dania',
        fi: 'Finlandia',
        bg: 'Bułgaria',
        hr: 'Chorwacja',
        lt: 'Litwa',
        lv: 'Łotwa',
        et: 'Estonia',
        sl: 'Słowenia',
        sr: 'Serbia',
        he: 'Izrael',
        fa: 'Iran',
        hi: 'Indie',
        id: 'Indonezja',
        ms: 'Malezja',
        th: 'Tajlandia',
        ka: 'Gruzja',
        sw: 'Szwajcaria',
    }
}